import React, { Component } from 'react';
import Select from 'react-select';
import DataPicker from './criterion/DataPicker'
import GA from '../lib/GoogleAnalyticsWrapper'
import './Criterion.css';
import InputError from './InputError'

class Criterion extends Component {
	constructor(props) {
    super(props);
    this.state = { selectValue: null, data: null };

    this.updateCriterionType = this.updateCriterionType.bind(this);
		this.dataUpdate = this.dataUpdate.bind(this);
		this.findType = this.findType.bind(this);
		this.validateData = this.validateData.bind(this);
  }

	findType(value) {
		for (var i = 0; i < this.props.options.length; i++) {
			if (value === this.props.options[i].value) {
				return this.props.options[i];
			}
		}
		throw new Error("did not find " + value + " in " + JSON.stringify(this.props.options));
	}

	updateCriterionType(newCriteria) {
		var newSelectValue = newCriteria != null ? this.findType(newCriteria.value) : null
		this.setState({
			selectValue: newSelectValue
		});
    this.props.updateCriterionType(this.props.index, newSelectValue);
		var data = newCriteria != null ? {smallValue : newSelectValue.defaultMin, largeValue : newSelectValue.defaultMax} : null;
		this.dataUpdate(data, newSelectValue);
		GA.pageview("criterion-type-" + newSelectValue);
	}

	dataUpdate(data, selectValue = this.state.selectValue) {
		var newState = this.validateData(selectValue, data);
		this.setState({data: data});
		this.setState(newState);
		var toUpdate = {
			value: data,
			valid: newState.valid
		};
		this.props.updateCriterionData(this.props.index, toUpdate);
	}

	empty(str) {
		// we are using != instead of !== because we want the casting behavior
    if ((!str && str !== "0" && str !== 0) || str.length === 0 || str === "" || !/[^\s]/.test(str) || /^\s*$/.test(str) || str.toString().replace(/\s/g,"") === "") {
			return true;
    }
    return false;
	}

	validateData(selectValue, data) {
		if (!data) {
			return {valid : true};
		}
		var smaller = data.smallValue;
		var larger = data.largeValue;
		if (isNaN(smaller) || this.empty(smaller)) return {valid : false, errorMessage : "Minimum value must be a number"};
		if (isNaN(larger) || this.empty(larger)) return {valid : false, errorMessage : "Maximum value must be a number"};
		smaller = parseFloat(smaller)
		larger = parseFloat(larger)
		if (larger < smaller) {
			return {valid : false, errorMessage : "Maximum value must be at least as large as the minimum"};
		}
		if (larger > selectValue.max || smaller < selectValue.min) {
			return {
				valid : false,
				errorMessage : "Maximum and minimum values must be between " + selectValue.max + " and " + selectValue.min
			};
		}
		return {valid : true};
	}

	render() {
		return (
			<div>
				<div className="section" style={{flexDirection: 'row'}}>
					<Select
							className="select"
							value={this.state.selectValue}
							onChange={this.updateCriterionType}
							clearable={true}
							options={this.props.options}
	            ref="stateSelect"
	            name="selected-state"
	        />
					<DataPicker className="picker" selectValue={this.state.selectValue} dataUpdate={this.dataUpdate} data={this.state.data}/>
				</div>
				<InputError
          visible={!this.state.valid}
          errorMessage={this.state.errorMessage} />
			</div>
		);
	}
}

export default Criterion;



// WEBPACK FOOTER //
// ./src/components/Criterion.js